<script>
    import TreeView from "./TreeView.svelte";

    export let categoryData = [];
</script>

<ul class="tree-container">
    {#each categoryData as category }
        <li class="nasted no_border">
            <TreeView {category} top="{true}"></TreeView>
        </li>
    {/each}
</ul>
